import { Avatar, AvatarProps } from 'stream-chat-react';

export const CustomAvatar = (props: AvatarProps) => {
  if (props.user?.image) {
    return <Avatar image={props.user.image as string} />;
  }

  return <Avatar name={props.user?.name ?? '?'} />;
};
